import React from "react";
import { services } from "../../servicesData";
import ServiceCard from "./ServiceCard";

export default function ServicesGrid() {
  return (
    <section className="mu-section">
      <div className="container">
        <div className="mb-4">
          <div className="mu-eyebrow" style={{ color: "var(--mu-purple-700)" }}>What We Offer</div>
          <h2 className="section-title">Our Services</h2>
        </div>

        <div className="row g-4">
          {services.map((s) => (
            <div className="col-md-6 col-lg-4" key={s.slug}>
              <ServiceCard service={s} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
